import React from 'react'
import clx from 'classnames'

export const CartOverviewButton = function Button({
  url,
  isLinkDisabled,
  validateStep,
  onClick,
  buttonText,
  buttonClasses = {}
}) {
  let button_props = {
    className: clx('button blue', buttonClasses, { disabled: isLinkDisabled }),
    onClick(e) {
      if (validateStep()) {
        e.preventDefault()
        return false
      }
      if (typeof onClick === 'function') {
        onClick(e)
      }
    }
  }
  return url != null ? (
    <a {...button_props} href={url}>
      {buttonText}
    </a>
  ) : (
    <button {...button_props}>{buttonText}</button>
  )
}
